<template>
	<div class="employer-detail-form">
		<ValidationObserver v-slot="{ invalid }" ref="observer">
			<b-form role="form" class="mt-4">
				<b-row>
					<b-col cols="8">
						<b-form-group label="Employer Name">
							<b-form-input v-model="form.current.name" type="text" placeholder="Enter company name"></b-form-input>
						</b-form-group>
					</b-col>

					<b-col cols="8">
						<b-form-group label="Position">
							<b-form-input v-model="form.current.position" type="text" placeholder="Position"></b-form-input>
						</b-form-group>
					</b-col>

					<b-col cols="8">
						<b-form-group label="Employment Period">
							<b-form-input v-model="form.current.length_of_service" type="number"
							placeholder="Employment Period"></b-form-input>
						</b-form-group>
					</b-col>

					<b-col cols="8">
						<b-form-group label="Company Address">
							<b-form-input v-model="form.current.address_1" type="text"
							placeholder="Enter Company Address"></b-form-input>
						</b-form-group>
					</b-col>

					<b-col cols="8">
						<b-form-group label="Company Contact">
							<ValidationProvider v-slot="{ errors }" :rules="{ number_only: true }" :vid="'number_only'">
								<b-form-input v-model="form.current.contact_no" type="text" maxlength="17" placeholder="Enter Company Telephone"
									@keydown="preventNonNumericInput">
								</b-form-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>

					<b-col cols="8">
						<b-form-group label="HR Contact">
							<ValidationProvider v-slot="{ errors }" :rules="{ number_only: true }" :vid="'number_only'">
								<b-form-input v-model="form.current.hr_contact_no" type="text" maxlength="17" placeholder="Enter Company HR Contact"
									@keydown="preventNonNumericInput">
								</b-form-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>

					<b-col cols="8">
						<b-form-group label="HR Email">
							<ValidationProvider v-slot="{ errors }" :rules="{ email: true }" :vid="'email'">
							<b-form-input v-model="form.current.hr_email" type="email"
								placeholder="Enter Company HR Email"></b-form-input>
							<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>

					<b-col cols="8">
						<b-button block variant="primary" class="w-50" @click.prevent="update" :disabled="invalid">Save</b-button>
					</b-col>
				</b-row>
			</b-form>
		</ValidationObserver>
	</div>
</template>
<script>
import { Select, Option, RadioGroup, RadioButton } from 'element-ui'
import { mapState, mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'
import { preventNonNumericInput } from '@/assets/js/formValidations.js'

export default {
	name: 'company-info-form',
	props: [],
	components: {
		ValidationObserver,
		ValidationProvider,
		[Select.name]: Select,
		[Option.name]: Option,
		[RadioGroup.name]: RadioGroup,
		[RadioButton.name]: RadioButton,
	},
	data() {
		return {
			form: {
				current: {
				name: '',
				position: '',
				length_of_service: 0,
				address_1: '',
				contact_no: '',
				hr_contact_no: '',
				hr_email: '',
				},
			},
		};
	},
	created() {
		this.form.current = this.activeCustomer.companies?.current || {};
	},
	computed: {
		...mapState(useCustomerStore, ['activeCustomer']),
	},
	methods: {
		preventNonNumericInput,
    	...mapActions(useCustomerStore, ['getCustomerIm2u', 'updateEmployments']),
		update() {
			const companies = [];

			if (this.form.current.name) {
				this.form.current.is_current = 1;
				companies.push({ ...this.form.current })
			}

			this.updateEmployments({companies}).then((res) => {
				_gNotif.notifySuccess('<b>Company Information: ' + this.activeCustomer.name + '</b> - Successfully Updated.');
				this.getCustomerIm2u(this.activeCustomer.customer_id);
			}).catch(e => {
				_gNotif.errorFunction(e);
			});
		}
  },
}
</script>